import React, { useContext, useEffect } from "react";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import Paper from "@mui/material/Paper";
import Grow from "@mui/material/Grow";
import FormControlLabel from "@mui/material/FormControlLabel";
import MyContext from "../context/MyContext";
import { SketchPicker } from "react-color";
import PopColorPicker from "../dashboard.component/dashboard.rightarea.component/PopColorPicker";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import ColorPickerIn from "./ColorPickerIn";
import { rgbToHex } from "lord-icon-element";
import AuthContext from "../context/userAuth.context";

const icon = (
  <Paper sx={{ m: 1 }} elevation={4}>
    <Box></Box>
  </Paper>
);
function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function CharacterEditor(SelectedColorTheme) {
  const [checked, setChecked] = React.useState(true);
  const [defaultColorSettings, setDefaultColorSettings] = React.useState([{}]);

  var PartNames = [
    {
      id: "1",
      name: "Hair",
      rgb: "",
    },
    {
      id: "2",
      name: "Skin",
      rgb: "",
    },
    {
      id: "3",
      name: "Shirt",
      rgb: "",
    },
    {
      id: "4",
      name: "EyeBro",
      rgb: "",
    },
    {
      id: "5",
      name: "Glasses",
      rgb: "",
    },
    {
      id: "6",
      name: "Bottom",
      rgb: "",
    },
    {
      id: "7",
      name: "Shoe",
      rgb: "",
    },
    {
      id: "8",
      name: "Eye",
    },
    {
      id: "9",
      name: "Beard",
      rgb: "",
    },
    {
      id: "10",
      name: "Coat",
      rgb: "",
    },
    {
      id: "11",
      name: "Tie",
      rgb: "",
    },
    {
      id: "12",
      name: "Cap",
      rgb: "",
    },
    {
      id: "13",
      name: "Mustache",
      rgb: "",
    },
  ];

  const [ColorSettings,setColorSettings] = React.useState([
    { part: "Shirt", rgba: "" },
    { part: "Bottom", rgba: "" },
    { part: "Tie", rgba: "" },
    { part: "Beard", rgba: "" },
    { part: "Glasses", rgba: "" },
    { part: "Skin", rgba: "" },
    { part: "Hair", rgba: "" },
    { part: "Eye", rgba: "" },
    { part: "EyeBro", rgba: "" },
    { part: "Coat", rgba: "" },
    { part: "Mustache", rgba: "" },
    { part: "Shoe", rgba: "" },
    { part: "Advanced", rgba: "" }
    
  ]);
  const {
    characterEditor,
    setCharacterEditor,
    LayersData,
    setLayersData,
    characterId,
  } = useContext(MyContext);
  const { authenticationData, Role, setAllProject } = useContext(AuthContext);

  const handleChange = () => {
    setCharacterEditor(false);
  };

  useEffect(async () => {
    const array = Array.from(LayersData);

    for (let i = 0; i < array.length; i++) {
      if (array[i].AnimationId === characterId) {
        //console.log(json);

        if (!array[i].JSONValue) {
          const resp = await fetch(
            authenticationData.ApiBaseURL + "/" + array[i].character_FilePath
          );
          array[i].JSONValue = await resp.json();
        }

        array[i].Added = true;
        LoadJSONSettings(array[i].JSONValue);
        setLayersData(array);
        //console.log(LayersData);
        break;
      }
    }
  }, [characterId]);

  const LoadJSONSettings = (json) => {
    LoadDefaultColorSettings(json);
    setDefaultColorSettings(PartNames);

    // setTieColor(json);
    // setBeard(json);
  };

  const LoadDefaultColorSettings = (json) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Hair") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Hair_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Hair")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Cap") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Cap_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Cap")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Mustache") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Mustache_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Mustache")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Shirt") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Tie_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Tie")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Shirt") {
        // var ShirtRgb = null;
        // var arr = [];
        // if (SelectedColorTheme.SelectedColorTheme !== undefined) {
        //   var arrayThemeColors =
        //     SelectedColorTheme.SelectedColorTheme.colors.split(",");
        //   ShirtRgb = hexToRgb(arrayThemeColors[0]);

        //   arr.push(ShirtRgb.r / 25 / 10);
        //   arr.push(ShirtRgb.g / 25 / 10);
        //   arr.push(ShirtRgb.b / 25 / 10);
        //   console.log("rgbVal", arr);
        // }

        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Shirt")[0].rgb =
                  skins[skn].it[it].c.k;
              }
              // if (ShirtRgb !== null) {
              //   if (skins[skn].it[it].ty === "fl") {
              //     PartNames.filter((part) => part.name == "Shirt")[0].rgb = arr;
              //   }
              // }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Coat") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Coat")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Glasses") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Glasses_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter(
                  (part) => part.name.trim() == "Glasses"
                )[0].rgb = skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Eye") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Eye_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Eye")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Shoe_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe1_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name.trim() == "Shoe")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }

          skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe2_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name.trim() == "Shoe")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }

          skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name.trim() == "Shoe")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Shoe_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe1_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name.trim() == "Shoe")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }

          skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe2_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name.trim() == "Shoe")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }

          skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name.trim() == "Shoe")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Hip") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Bottom")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "EyeBro") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "EyeBro_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "EyeBro")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Beard") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Beard_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Beard")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Face") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Skin")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setTieColor = (json) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Shirt") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Tie_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = 0.91111;
                skins[skn].it[it].c.k[1] = 0.21111;
                skins[skn].it[it].c.k[2] = 0.41111;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
        break;
      }
    }
  };

  const setSkinColor = (json) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Face") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = 0.91111;
                skins[skn].it[it].c.k[1] = 0.21111;
                skins[skn].it[it].c.k[2] = 0.41111;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "EyeShut1") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = 0.91111;
              skins.it[it].c.k[1] = 0.21111;
              skins.it[it].c.k[2] = 0.41111;
            }
          }
        }
      } else if (name == "EyeShut2") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = 0.91111;
              skins.it[it].c.k[1] = 0.21111;
              skins.it[it].c.k[2] = 0.41111;
            }
          }
        }
      } else if (name == "Body") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = 0.91111;
              skins.it[it].c.k[1] = 0.21111;
              skins.it[it].c.k[2] = 0.41111;
            }
          }
        }
      } else if (name == "Hand_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = 0.91111;
              skins.it[it].c.k[1] = 0.21111;
              skins.it[it].c.k[2] = 0.41111;
            }
          }
        }
      } else if (name == "Hand_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = 0.91111;
              skins.it[it].c.k[1] = 0.21111;
              skins.it[it].c.k[2] = 0.41111;
            }
          }
        }
      }
    }
  };

  const handleColorChange = (color) => {
  };

  return (
    <Box sx={{ height: 180 }}>
      {/* <FormControlLabel
        control={<Switch checked={checked} onChange={handleChange} />}
        label="Show Editor"
      /> */}
      <Box sx={{ display: "flex" }}>
        {/* Conditionally applies the timeout prop to change the entry speed. */}
        <Grow
          in={checked}
          style={{ transformOrigin: "0 0 0" }}
          {...(checked ? { timeout: 1000 } : {})}
        >
          <div>
            {/* <SketchPicker /> */}

            {/* <PopColorPicker /> */}

            <Grid
              justifyContent="center"
              alignItems="center"
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            >
              {defaultColorSettings.map(
                (item, index) =>
                  item.rgb != undefined &&
                  item.rgb != "" && (
                    <>
                      <Grid item xs={6}>
                        <FormLabel>{item.name}</FormLabel>
                      </Grid>
                      <Grid item xs={6}>
                        <ColorPickerIn
                          Name={item.name}
                          key={index}
                          rgb={item.rgb}
                          value={item}
                          onChange={handleColorChange}
                          characterId={characterId}
                          LoadJSONSettings={LoadJSONSettings}
                          ColorSettings={ColorSettings}
                          setColorSettings={setColorSettings}
                        ></ColorPickerIn>
                      </Grid>
                    </>
                  )
              )}
            </Grid>
          </div>
        </Grow>
      </Box>
    </Box>
  );
}

export default CharacterEditor;
